import { getFlags } from '@tix/flags';
import { environment, portal } from '@/helpers/Environment';
import { logInTrackJS } from '@/errors/helpers';
const lastEmitted = new Map();
let hasTrackedError = false;
const evalOptions = {
    onFlagEvaluated: sendFlagToAnalytics,
};
export function evaluateFlags(identity) {
    const rules = environment.config_cat;
    if (!rules) {
        // track missing embed, but not in jest environment
        if (window.tix) {
            trackOnce(new Error('ConfigCat embed missing'));
        }
        return {};
    }
    const resolvedIdentity = identity?.id ? { id: identity.id, email: identity.email ?? undefined } : undefined;
    const flagUser = { tenant: portal.slug ?? '', ...resolvedIdentity };
    const result = getFlags(rules, flagUser, evalOptions);
    if (result.success)
        return result.flags;
    trackOnce(result.error instanceof Error ? result.error : new Error(String(result.error)));
    return {};
}
function sendFlagToAnalytics(details) {
    if (!Array.isArray(window.dataLayer))
        return;
    const signature = `${details.key}:${String(details.value)}`;
    if (lastEmitted.get(details.key) === signature)
        return;
    lastEmitted.set(details.key, signature);
    if (!details.variationId) {
        logInTrackJS('ConfigCat flag is missing variationId', details);
    }
    window.dataLayer.push({
        event: 'configcat_flag_evaluated',
        exp_variant_string: `configcat-${details.key}-${details.value}`,
        variation_id: details.variationId ?? `${details.key}-${details.value}`,
    });
}
function trackOnce(error) {
    if (hasTrackedError)
        return;
    hasTrackedError = true;
    logInTrackJS('ConfigCat embed evaluation failed', { cause: error });
}
